import { useEffect, useRef } from "react";

export const Cursor = () => {
  const ref = useRef(null);
  useEffect(() => {
    if (window.matchMedia("(pointer: coarse)").matches) return;
    const el = ref.current;
    const move = (e) => {
      el.style.transform = `translate(${e.clientX}px, ${e.clientY}px) translate(-50%, -50%)`;
      const hot = e.target.closest("a, button, [data-cursor-hover]");
      el.classList.toggle("is-hover", !!hot);
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => window.removeEventListener("mousemove", move);
  }, []);
  return <div ref={ref} className="wam-cursor" style={{ opacity: 0.9 }} />;
};
